import React, { useContext, useState } from 'react';
import { OrderType } from '../../../interfaces/delivery-company/orders';
import CustomDialog from '../custom-dialog/custom-dialog';
import {
  DialogTitle,
  Typography,
  DialogContent,
  Stack,
  Button,
  CircularProgress,
  DialogActions,
  TextField,
  Box,
  Alert,
} from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import axios from 'axios';
import { API_ENDPOINT } from '../../../configurations/global.config';
import { AuthContext } from '../../../contexts/user-context/user-context';
import { format } from 'date-fns';
import { useSnackBar } from '../../../contexts/snackbar';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { BulkActionProps } from './props.interface';
import { DeliveryState } from '../../../enums/orders';



function ResumeDelivery({
  selectedOrders,
  bulkEndpoint,
  refetchOrders,
  onFinishAction,
}: BulkActionProps & {  onFinishAction: ()=>void;}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { config } = useContext(AuthContext);
  const { showMessage } = useSnackBar();

  const nonApplicable = Array.from(selectedOrders.values()).filter(order => order.delivery_state != DeliveryState.AWAITING_RETURN)
  const applicable = Array.from(selectedOrders.values()).filter(order => order.delivery_state == DeliveryState.AWAITING_RETURN)

  const resume = async () => {
    try {
      setLoading(true);
      const response = await axios.post<OrderType>(
        `${API_ENDPOINT}/api/v1/delivery-tasks/resume/`,
        { order_ids: applicable.map(o=>o.id) },
        config
      );
      showMessage(`Success!`);
      refetchOrders(); 
      onFinishAction();
    } catch {
      showMessage('Operation Failed', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    setError('');

    try {
      setLoading(true);
      await resume();
    } catch (err) {
      setError('Something went wrong.');
    } finally {
      setLoading(false);
    }
  };

    if (applicable.length == 0) 
        return <Alert severity='warning'>The selected orders are not being delivered at the moment.</Alert>
    return (
    <Box>
      <Typography align={"center"}>
        {selectedOrders.size} Orders Selected
      </Typography>

      {nonApplicable.length > 0 && <Alert sx={{ mb :2}} severity="warning">The following {nonApplicable.length} orders will be skipped because they are not being delivered at the moment <br /><br />             
                {
                    nonApplicable.map((order: OrderType) => order.order_id).join(", ")
                }
        </Alert>}
              
        <Alert sx={{mt: 1, mb: 1}} severity="info"> Are you sure you want to resume delivery of the selected orders?</Alert>
        <Box width={"100%"} display={"flex"} justifyContent={"center"}>
          <Button sx={{mt: 2}} onClick={handleSubmit} variant="contained" disabled={loading}>
          {loading ? <CircularProgress size={20} /> : 'Proceed'}
        </Button>


        </Box>
        

    </Box>
  );
}

export default ResumeDelivery;
